import { rootElement } from '@shared/setup';
import BlockTargetAudienceManagement from './BlockTargetAudienceManagement.vue';

const initBlockTargetAudienceManagement = async () => {
    rootElement({
        name: 'block-target-audience-management',
        component: BlockTargetAudienceManagement,
        vm: {},
        contextComponents: ['<div>Loading statistics...</div>'],
    });
};

initBlockTargetAudienceManagement();
